// import React from "react";
import { useState } from "react";
import InnerHero from "../components/InnerHero";
import productsData from "../data/products";
import ProductModal from "../components/ProductCard";
import UsageSafety from "../components/UsageSafety";
import CTASection from "../components/CTASection";

function Fertilizer() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    // 🔹 SIRF INSECTICIDE PRODUCTS
    const insecticideProducts = productsData.filter(
        product => product.category === "Fertilizer"
    );
    return (
        <>
            <InnerHero
                title="Fertilizers"
                subtitle="Balanced plant nutrition solutions to improve soil fertility, crop growth, and overall yield quality."
                breadcrumb="Home / Products"
                bgImage="/images/img/ferti.jpg"
            />

            <section className="category-intro-section">
                <div className="container">
                    <div className="row align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="category-intro-content">
                                <h6 className="section-subtitle">CATEGORY OVERVIEW</h6>
                                <h2>
                                    Balanced <span>Plant Nutrition</span> for Sustainable Growth
                                </h2>

                                <p>
                                    Proper plant nutrition plays a vital role in crop growth,
                                    yield development, and long-term soil health. Deficiency of
                                    essential nutrients can directly impact crop performance
                                    and farmer profitability.
                                </p>

                                <p>
                                    Goodweel Crop Care fertilizers are formulated to supply
                                    essential macro and micro nutrients required at different
                                    stages of crop growth. Our products help improve soil
                                    fertility, strengthen root development, and support
                                    uniform crop growth.
                                </p>

                                <p>
                                    With consistent quality and easy application, our
                                    fertilizers help farmers achieve higher yields, better
                                    crop quality, and sustainable agricultural productivity.
                                </p>
                            </div>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="col-lg-6">
                            <div className="category-intro-image">
                                <img
                                    src="/images/img/18.jpg"
                                    alt="Fertilizers Plant Nutrition"
                                    className="img-fluid"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* SECTION HEADING */}
            <div className="container text-center my-5">
                <h2 className="section-title">
                    Our <span>Fertilizer Products</span>
                </h2>
                <p className="section-desc">
                    Explore our range of high-quality fertilizers designed
                    to improve soil fertility, enhance nutrient uptake,
                    and support healthy crop development.
                </p>
            </div>

            {/* PRODUCTS GRID (CSS SAME AS PRODUCT PAGE) */}
            <div className="container">
                <div className="row">
                    {insecticideProducts.map(product => (
                        <div
                            className="col-lg-3 col-md-4 col-sm-6 mb-4 Product-col"
                            key={product.id}
                        >
                            <div
                                className="product-card"
                                onClick={() => setSelectedProduct(product)}
                            >
                                <img
                                    src={product.image}
                                    alt={product.name}
                                />
                                <div className="product-overlay">
                                    <h6>{product.name}</h6>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* SAFETY CHECK */}
                    {insecticideProducts.length === 0 && (
                        <p className="text-center mt-4">
                            No fertilizer  products available at the moment.
                        </p>
                    )}
                </div>
            </div>

            {/* PRODUCT DETAILS MODAL (UNCHANGED) */}
            {selectedProduct && (
                <ProductModal
                    product={selectedProduct}
                    close={() => setSelectedProduct(null)}
                />
            )}
            <UsageSafety />
            <CTASection />

        </>
    );
};

export default Fertilizer;
